"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function setContainerDimensions() {
    return (state, actions, { tabName = state.ui.currentTabName, dimensionType, changes }) => {
        const newDimension = Object.assign({}, state.tabs[tabName].containerDimensions, changes);
        return Object.assign({}, state, { tabs: Object.assign({}, state.tabs, { [tabName]: Object.assign({}, state.tabs[tabName], { [dimensionType === 'original' ? 'originalContainerDimensions' : 'containerDimensions']: Object.assign({}, newDimension) }) }) });
    };
}
exports.setContainerDimensions = setContainerDimensions;
//# sourceMappingURL=set-container-dimensions.js.map